import { render, staticRenderFns } from "./PromotionsTabLinks.vue?vue&type=template&id=638fe25b"
import script from "./PromotionsTabLinks.vue?vue&type=script&lang=js"
export * from "./PromotionsTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports